import { gql } from '@apollo/client'

export const MUTATION = gql`
    mutation StoreCredential($input: StoreCredentialInput!) {
        storeCredential(input: $input)
    }
`

export const UpdatePayableAddress = gql`
    mutation UpdateUserProfile($input: UpdateUserProfileInput) {
        updateUserProfile(input: $input) {
            id
            email
            firstName
            lastName
            phone
            dateOfBirth
            countryId
            lastLoginDate
            givenConsentDate
            removedConsentDate
            notifyEmail
            notifyPhone
            payableAddress
        }
    }
`
